import { render, staticRenderFns } from "./PreviewFormsTRIS.vue?vue&type=template&id=5041a6e8"
import script from "./PreviewFormsTRIS.vue?vue&type=script&lang=ts"
export * from "./PreviewFormsTRIS.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports